import Select from 'react-select';

import { OPTIONAL_TEXT, RESET } from '#/utils/constants';

function CustomSelectPicker({
  label,
  options,
  value,
  onChange,
  menuPlacement = 'auto',
  isDisabled,
  placeholder = 'Select...',
  isError,
  errorMessage,
  allowReset,
  resetLabel = 'Select option',
  isRequired = true,
  optionalLabelText = OPTIONAL_TEXT,
  isMultiple = false,
  ...props
}) {
  const finalPlaceholder = `${placeholder}${isRequired ? '*' : ` (${optionalLabelText})`}`;

  const handleChange = selected => {
    if (isMultiple) {
      const selectedValues = selected?.map(opt => opt.label) || [];
      onChange(selectedValues);
    } else if (selected?.value === RESET) {
      onChange(null);
    } else {
      onChange(selected?.label);
    }
  };

  const formatValue = () => {
    if (isMultiple) {
      return Array.isArray(value) ? options?.filter(opt => value.includes(opt.label)) : [];
    }
    return options?.find(opt => opt.label === value?.label) || null;
  };

  const optionsWithReset = allowReset && !isMultiple ? [{ value: RESET, label: resetLabel }, ...options] : options;

  return (
    <div className="custom-select-picker">
      {label && <label>{label}</label>}
      <Select
        isMulti={isMultiple}
        value={formatValue()}
        options={optionsWithReset}
        maxMenuHeight={200}
        menuPlacement={menuPlacement}
        isDisabled={isDisabled}
        isClearable={false}
        onChange={handleChange}
        placeholder={finalPlaceholder}
        classNamePrefix={`${isError ? 'error-select-field' : ''} select-field`}
        {...props}
      />
      {isError && errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

export default CustomSelectPicker;
